export const OrgLinks = {
  sweetgreen: 'https://www.sweetgreen.com/',
  faqs: 'https://faq.sweetgreen.com/',
  contact: 'https://www.sweetgreen.com/contact',
  instagram: 'https://www.instagram.com/sweetgreen/',
  twitter: 'https://twitter.com/sweetgreen',
  tiktok: 'https://www.tiktok.com/@sweetgreen',
  spotify: 'https://open.spotify.com/user/1224421164',
  facebook: 'http://facebook.com/sweetgreen',
  privacy: 'https://www.sweetgreen.com/privacy-policy',
  terms: 'https://www.sweetgreen.com/terms',
  personal: 'http://www.sweetgreen.com/privacy-policy/ca-data-opt-out',
  ios: 'https://itunes.apple.com/us/app/sweetgreen/id594329490?mt=8',
  android:
    'https://play.google.com/store/apps/details?id=com.sweetgreen.android.app&hl=en',
};
